export default "__VITE_ASSET__DbPVgrek__"